<template>

  <v-switch
    inset
    v-bind="computedProps"
    v-on="computedListeners"/>

</template>
<script>
import controls from '@/rahmen/controls'
import validators from '@/rahmen/validators'
import inputMixin from '@/mixins/inputMixins'
import { VSwitch } from 'vuetify/lib'

/**
 * @file DDv2用スイッチ
 * @namespace components
 */

/**
 * @vue-prop {Boolean} [required=false] - 必須制御有無
 * @vue-prop {String} [errorMessages=''] - 表示エラーメッセージ
 * @see https://vuetifyjs.com/ja/api/v-switch/
 * @example
 * <dd-switch
 *   v-model="checkValue"
 *   :required="true"
 * />
 */
export default {
  name: 'DdSwitch',
  extends: VSwitch,
  mixins: [inputMixin],
  props: {
    /**
     * 必須指定
     */
    required: Boolean,
    /**
     * 表示エラーメッセージ
     */
    errorMessages: String
  },
  data: () => ({
    invalidMessage: ''
  }),
  created () {
  },
  mounted () {
    this.invalidMessage = this.errorMessages
    this[controls.VALIDATE_METHOD]()
  },
  computed: {
    computedProps () {
      return {
        ...this.$props,
        // backgroundColor: this.required ? controls.Colors.Required : '',
        class: this.required ? ' required-item' : this.class,
        hideDetails: true,
        dense: true,
        error: this.hasError,
        errorMessages: this.invalidMessage,
        falseValue: false,
        trueValue: true
      }
    },
    computedListeners () {
      return {
        ...this.$listeners,
        blur: e => this.onBlur(e)
      }
    },
    hasError () {
      return this.invalidMessage
    }
  },
  methods: {
    onBlur: function (e) {
      this[controls.VALIDATE_METHOD]()
      if (!this.hasError) {
        this[controls.FORMAT_METHOD]()
      }
    },
    [controls.VALIDATE_METHOD]: function () {
      const target = {
        value: this.value,
        length: this.length
      }

      this.invalidMessage = undefined
      const validatorList = []

      if (this.required) { validatorList.unshift(validators.requireValidate) }
      if (this.appendValidators) { validatorList.push(...this.appendValidators) }

      for (let i = 0; i < validatorList.length; i++) {
        const f = validatorList[i]
        const ret = f(target)
        if (ret !== undefined) {
          this.invalidMessage = ret
          return
        }
      }
    },
    [controls.FORMAT_METHOD]: function () {
    }
  }
}
</script>
<style scoped>
</style>
